import { useEffect, useState } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useAuth } from '../contexts/AuthContext';

export const useIntercom = () => {
  const { user } = useAuth();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) return;

    // Authenticated user — full identity verification
    if (user?.attributes) {
      const initIntercom = async () => {
        try {
          const response = await fetch('https://oauth.remote-assistant.ai/intercom/jwt', {
            headers: {
              'Authorization': `Bearer ${window.authToken}`
            }
          });

          if (!response.ok) {
            console.error('Failed to fetch Intercom JWT');
            return;
          }

          const { user_hash } = await response.json();
          const createdAt = user.attributes['custom:created_at']
            ? parseInt(user.attributes['custom:created_at'])
            : Math.floor(Date.now() / 1000);

          Intercom({
            app_id: 'ymve6uz7',
            user_id: user.userId,
            name: `${user.attributes.given_name || ''} ${user.attributes.family_name || ''}`.trim() || user.attributes.email,
            email: user.attributes.email,
            created_at: createdAt,
            user_hash: user_hash,
            business_id: user.attributes['custom:business_id'],
            subscription_status: user.attributes['custom:subscription_status'],
            setup_completed: user.attributes['custom:setup_completed']
          });

          setInitialized(true);
        } catch (error) {
          console.error('Intercom initialization error:', error);
        }
      };

      initIntercom();
    } else {
      // Visitor mode — no auth required, tagged as sales inquiry
      Intercom({
        app_id: 'ymve6uz7',
        source: 'remote-assistant.ai',
        inquiry_type: 'sales',
      });
      setInitialized(true);
    }

    return () => {
      if (window.Intercom && initialized) {
        window.Intercom('shutdown');
        setInitialized(false);
      }
    };
  }, [user, initialized]);
};
